/* eslint-disable max-len */
export const ClickupIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 48 48" fill="currentColor">
            <g transform="translate(2.4 2.4) scale(1.8)">
                <path fill="currentColor" d="M2 18.439l3.69-2.828c1.961 2.56 4.044 3.739 6.363 3.739 2.307 0 4.33-1.166 6.203-3.704L22 18.405C19.298 22.065 15.941 24 12.053 24 8.178 24 4.788 22.078 2 18.439zM12.04 6.15l-6.568 5.66-3.036-3.52L12.055 0l9.543 8.296-3.05 3.509z" />
            </g>
        </svg>
    );
};
